// Handle quantity changes on the cart page
document.querySelectorAll('.quantity__input').forEach(input => {
  input.addEventListener('change', function () {
    const itemId = this.dataset.quantityVariantId; // Retrieve the variant ID
    const newQuantity = this.value;

    // AJAX request to update cart quantity
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemId,
        quantity: newQuantity
      })
    })
    .then(response => response.json())
    .then(() => {
      // Reload the page after updating the cart
      location.reload();
    })
    .catch(error => console.error('Error updating cart:', error));
  });
});

// Handle item removal on the cart page
document.querySelectorAll('cart-remove-button a').forEach(button => {
  button.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent the default link action

    // Extract variant ID from the link's href
    const url = new URL(button.href);
    const itemId = url.searchParams.get('id').split(':')[0];

    // AJAX request to remove item
    fetch(`/cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemId,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(() => {
      // Reload the page after 0.5 seconds
      setTimeout(() => location.reload(), 500);
    })
    .catch(error => console.error('Error removing item:', error));
  });
});
